import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {ViewType} from '@shared/enums/view-type.enum';


@Component({
  selector: 'app-view-switcher',
  templateUrl: './view-switcher.component.html',
  styleUrls: ['./view-switcher.component.scss']
})
export class ViewSwitcherComponent implements OnInit {


  @Input() selectedView: ViewType | null = null;
  @Output() changeViewType = new EventEmitter<ViewType>();

  public ViewType = ViewType;

  constructor(
  ) { }

  ngOnInit(): void {
  }

  public changeType(view: ViewType): void {
    this.changeViewType.emit(view);
  }
}
